<template>
  <div class="cb-assistance">
    <p class="cb-body-1 cb-assistance__body">
      <strong>For assistance call</strong>
    </p>
    <a
      @click.prevent="handleAssistanceClick"
      href="tel:800-724-9097"
      :data-tab-order="tabOrder"
      class="cb-link cb-body-1 cb-assistance__link"
      >(800) 724-9097</a
    >
  </div>
</template>

<script>
/* global gtag */

export default {
  props: ['tabOrder'],
  methods: {
    handleAssistanceClick() {
      gtag('event', 'assistanceClick', {
        event_label: 'call for assistance',
        event_category: 'assistance',
        value: 1,
      });
      window.location.href = 'tel:800-724-9097';
    },
  },
};
</script>

<style lang="scss" scoped>
.cb-assistance {
  text-align: center;
  display: flex;
  justify-content: center;

  &__body {
    margin: 0 6px 0 0;
  }

  &__link {
    margin: 0 0 0 6px;
  }
}
</style>
